import WIDGETS from './widgets';

export default {
	name: 'kind_bottom_slider_article_menu',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.KIND_BOTTOM_SLIDER_ARTICLE_MENU, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
